import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { SharedPlaceholderComponent } from '../../components/shared-placeholder/shared-placeholder.component';
import { SisButtonComponent } from '../../components/sis/sis-button/sis-button.component';
import { SisCheckboxComponent } from '../../components/sis/sis-checkbox/sis-checkbox.component';
import { SisDateFieldComponent } from '../../components/sis/sis-date-field/sis-date-field.component';
import { SisFieldComponent } from '../../components/sis/sis-field/sis-field.component';
import { SisFieldLoadingDirective } from '../../components/sis/sis-field-loading.directive';
import { SisHintComponent } from '../../components/sis/sis-hint/sis-hint.component';
import { SisRadioGroupComponent } from '../../components/sis/sis-radio-group/sis-radio-group.component';
import { SisSelectComponent } from '../../components/sis/sis-select/sis-select.component';
import { SisStatusChipComponent } from '../../components/sis/sis-status-chip/sis-status-chip.component';
import { SisToastComponent } from '../../components/sis/sis-toast/sis-toast.component';
import { MaterialModule } from '../../material/material.module';

@NgModule({
  declarations: [
    SharedPlaceholderComponent,
    SisButtonComponent,
    SisCheckboxComponent,
    SisDateFieldComponent,
    SisFieldComponent,
    SisFieldLoadingDirective,
    SisHintComponent,
    SisRadioGroupComponent,
    SisSelectComponent,
    SisStatusChipComponent,
    SisToastComponent
  ],
  imports: [
    CommonModule,
    A11yModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MaterialModule
  ],
  exports: [
    CommonModule,
    A11yModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MaterialModule,
    SharedPlaceholderComponent,
    SisButtonComponent,
    SisCheckboxComponent,
    SisDateFieldComponent,
    SisFieldComponent,
    SisFieldLoadingDirective,
    SisHintComponent,
    SisRadioGroupComponent,
    SisSelectComponent,
    SisStatusChipComponent,
    SisToastComponent
  ]
})
export class SharedModule {}
